<template>
    <div id="chongbi" class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('chongbi.title')}}</div>
            <img class="link" src="@/assets/jilu.png" @click="record" alt="">
        </div>
        <div class="cont-box">
            <router-link class="select-box" to="/selectCbBz" tag="ul">
                <li class="t1">{{currency}}</li>
                <li class="t2">{{this.$t('chongbi.xzbz')}}</li>
                <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <div class="tips">{{this.$t('chongbi.lianmc')}}</div>
            <ul class="tab-box" v-show="currency == 'USDT'">
                <li class="tab" :class="{active: tabIdx == index}" v-for="(item,index) in addressList" :key="index" @click="change(item.value,item.address,index)">{{item.value}}</li>
            </ul>
            <div id="qriously" class="center ewm-img"><qriously :value="address" :size="125"/></div>
            <!-- <div class="center"><a id="downLoad" class="btn-save" download="QR.png" :href="downLoadUrl">{{this.$t('chongbi.bcewm')}}</a></div> -->
            <div class="tips">
                <div>{{this.$t('chongbi.cbdz')}}</div>
                <!-- <div class="copy" @click="copy($event)">{{this.$t('chongbi.fz')}}</div> -->
            </div>
            <div class="input-ads">
                <div>{{address}}</div>
                <img class="icon" src="@/assets/copy3.png" @click="copy($event)" alt="">
            </div>
            <!-- <div class="tips">{{this.$t('chongbi.sl')}}</div>
            <div><input class="input" type="number" name="number" v-model="number" min="0" @keyup="keyMoney()" :placeholder="$t('chongbi.qsrsl')" autocomplete="off"></div> -->

            <!-- <div class="tips">{{this.$t('chongbi.hxz')}}</div>
            <div><input class="input" type="text" name="certificate" v-model="certificate" :placeholder="$t('chongbi.qsrhxz')" autocomplete="off"></div>
            <div class="tips">{{this.$t('chongbi.pztp')}}</div>
            <div v-if="certificate_url"><img class="upload" :src="certificate_url" alt="" @click="upload"></div>
            <div v-else><img class="upload" src="@/assets/btn-upload.png" alt="" @click="upload"></div> -->
            <div class="tips">{{this.$t('usdttb.wxts')}}</div>
            <div class="tips-text">{{this.$t('chongbi.tips2')}}</div>
            <div class="tips-text">{{this.$t('chongbi.tips3')}}</div>
            <div class="tips-text">{{this.$t('chongbi.tips4')}}</div>
            <!-- <div class="tips-text">{{this.$t('chongbi.tips5')}}</div> -->
        </div>
        <!-- <div class="btn-box">
            <div class="btn" @click="sure">{{this.$t('chongbi.sure')}}</div>
        </div> -->
        <loading v-show="isLoad"></loading>
        <input class="___input" type="file" ref="foreheadCir" mutiple="mutiple" accept="image/*" style="display: none;">
    </div>
</template>
<script>
import VueQriously from 'vue-qriously'
import loading from '@/components/loading.vue'
import lrz from "lrz";
export default {
    name: 'chongbi',
    data () {
        return {
            uid: '',
            token: '',
            isLoad: false,
            tabIdx: 0,
            currency: 'USDT',
            addressList: [],
            address: '',
            chain: '',
            number: '',
            type: '',
            certificate: '',
            certificate_url: '',
            tag: '',
            downLoadUrl: '',
            count: 1
        }
    },
    created(){
      this.token = localStorage.getItem('token');
      this.type = this.$route.query.type || 1;
      this.currency = localStorage.getItem('cbBzName') || 'USDT'
    },
    mounted(){
      this.getChainList()
    },
    methods: {
      goBack(){
           this.$router.push('/index')
       },
       record(){
           this.$router.push('/cbjl?idx=0')
       },
       change(chain,ads,idx){
           this.tabIdx = idx;
           this.chain = chain;
           this.address = ads;
       },
       select(){
           this.$router.push({ path: '/selectCurrency', query: { type: 1,url: 'deposit' } })
       },
       getChainList(){
           let params = {
               currency: this.currency
           }
           this.$ajax.get('/web/getChainList',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.length > 0){
                    this.addressList = resData;
                    this.address = resData[0].address;
                    this.chain = resData[0].value;
                    var imgData = $("canvas")[0].toDataURL('png');
                    this.downLoadUrl = imgData;
                }else{ //暂未开放充值
                    // this.$router.push('/user')
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       sure(){
           var params = {
                'number': this.number,
                'address': this.address,
                'currency': this.currency,
                'type': this.type,
                'certificate_url': this.certificate_url,
                'certificate': this.certificate,
                'chain': this.chain,
                'tag': this.tag
            };
            if(params.number == '' || params.number == null || params.number <= 0){
                this.$toast.center(this.$t('chongbi.qsrsl'));
                return false;
            }
            // if(params.certificate_url == '' || params.certificate_url == null){
            //     this.$toast.center(this.$t('tipsNew.qscpztp'));
            //     return false;
            // }
            if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
            this.$ajax.post('/web/assetRecharge',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    this.$toast.center(this.$t('status.statusText')[2]);
                    setTimeout(() => {
                      this.count = 1;
                      this.$router.push('/cbjl?idx=0')
                    }, 1000)
                }else{
                    this.count = 1;
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
      upload(){
          var that = this;
          this.uploadimg(function (res) {
              that.certificate_url = res.url
          })
      },
      uploadimg(callback){
			    let that = this;
			    that.ele_input(function(res) {
            if (res.length > 0) {
              var formdata = new FormData();
              for (var i = 0, len = res.length; i < len; i++) {
                lrz(res[0]).then(function (rst) {
                  var formdata = new FormData();
                  let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                  formdata.append('file', file);
                  formdata.append('token', that.token);
                  formdata.append('app', 'h5');
                  that.isLoad = true;
                  $.ajax({
                    url: that.domain + "/web/uploadImg",
                    type: "POST",
                    data: formdata,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                      if (typeof data == 'string') data = JSON.parse(data.data)
                      if (data && data.code == 0) {
                        that.isLoad = false;
                        that.certificate_url = data.data.url;
                      }else{
                        that.isLoad = false;
                        that.$toast.center(data.message);
                        return;
                      }
                    },error: function(data) {
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  });
                })
              }
            }
			  })
		  },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
          // inputs.remove(0)
          // inputs.removeChild && inputs.removeChild(0)
        }
        inputs.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        inputs.click();
      },
      hideLoad(){
          this.isLoad = false;
      },
      copy(e){
          let address = this.address;
          this.$copyText(address, this.$t('chongbi.fzcg'));
          this.$toast.center(this.$t('chongbi.fzcg'));
      },
      keyMoney(){
          this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
              this.number = parseFloat(this.number);
          }
      },
    },
    components:{
		  loading
    },
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #666;
        font-size: .38rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .center{
        text-align: center;
    }
    .head{
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0E1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .link{
        position: absolute;
        right: .36rem;
        top: .24rem;
        width: .6rem;
        height: .6rem;
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: 1.2rem;
        bottom: 1.6rem;
        width: 100%;
        height: auto;
        padding: 0 .24rem .5rem;
        color: #000;
        font-size: .36rem;
        /* background: #0E1530; */
        box-sizing: border-box;
        overflow-y: auto;
    }
    .select-box{
        display: flex;
        align-items: center;
        padding: .5rem 0 .3rem;
        border-bottom: 1px solid #313a47;
    }
    .select-box .t1{
        flex: 1;
        color: #fff;
        font-size: .48rem;
    }
    .select-box .t2{
        padding-right: .24rem;
        color: #d2d2d2;
        font-size: .42rem;
    }
    .select-box .arrow{
        width: .18rem;
        height: .36rem;
    }
    .cont-box .tips{
        display: flex;
        justify-content: space-between;
        padding: .62rem 0 .2rem;
        color: #ababab;
        font-size: .42rem;
    }
    .cont-box .tips .copy{
        color: #4bb3e8;
    }
    .tab-box{
        display: flex;
        justify-content: flex-start;
        flex-flow: wrap;
        padding: 0 .1rem .2rem;
    }
    .tab-box .tab{
        position: relative;
        width: 30%;
        height: 1rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1rem;
        margin: 0 .2rem .1rem 0;
        border-radius: 4px;
        background: rgba(70, 89, 148,.2);
        text-align: center;
    }
    .tab-box .tab.active::after{
        position: absolute;
		right: 0;
		bottom: 0;
		content: '';
		width: .7rem;
		height: .78rem;
		background: url('./../assets/Trend_Selected.png') no-repeat right center;
		background-size: .5rem .56rem;
    }
    .ewm-text{
        padding: .46rem 0 .28rem;
        color: #bababa;
        font-size: .39rem;
    }
    .ewm-img{
        display: flex;
        justify-content: center;
    }
    .btn-save{
        display: inline-block;
        width: 4.2rem;
        height: 1.2rem;
        margin-top: .56rem;
        text-decoration: none;
        color: #fff;
        font-size: .42rem;
        line-height: 1.2rem;
        border-radius: .56rem;
        background: linear-gradient(267deg,rgba(44, 170, 222, 0.2), rgba(93, 205, 233, 0.2));
        text-align: center;
    }
    .input-ads{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #D2D2D2;
        padding: .22rem .25rem .18rem;
        font-size: .36rem;
        border-radius: 10px;
        background: rgba(4, 9, 37,.5);
        /* background: #040925; */
        word-break: break-word;
        box-sizing: border-box;
        text-align: center;
    }
    .input-ads .icon{
        padding-left: .4rem;
        width: .56rem;
        height: .56rem;
    }
    .input{
        width: 100%;
        height: 1.2rem;
        padding: 0 .25rem;
        color: #fff;
        font-size: .42rem;
        border: 1px solid #515151;
        border-radius: 6px;
        /* background: #0e1530; */
        background: transparent;
        box-sizing: border-box;
    }
    .upload{
        width: 3.2rem;
        height: 2.8rem;
        opacity: .8;
    }
    .btn-box{
        position: absolute;
        bottom: .28rem;
        width: 100%;
        padding: 0 .3rem;
        box-sizing: border-box;
        /* background: #0e1530; */
    }
    .tips{
        padding: .5rem .24rem .4rem;
        color: #ababab;
        font-size: .42rem;
    }
    .tips-text{
        padding: 0 0 .2rem;
        color: #ababab;
        font-size: .42rem;
    }
    .btn{
        width: 100%;
        height: 1.2rem;
        color: #fff;
        font-size: .42rem;
        line-height: 1.2rem;
        background: linear-gradient(left,  rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .14rem;
        text-align: center;
    }
</style>
<style>
    #chongbi canvas{
        background: #fff!important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/deposit.vue